<template>
<div>
    <Breadcrumbs main="Admin" submain="Content" title="Research" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div style="display: flex; justify-content: space-between; gap: 8px;">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New</h7>
                            </button>
                            <div v-if="serial_wise_data.length > 0">
                                <button class="btn btn-secondary" type="submit" @click="updateBulkSerial">Update Bulk Serial</button>
                            </div>
                        </div>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="research_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(title)="data">
                                        <div style="max-width: 250px;">
                                            {{ data.item?.title }}
                                        </div>
                                    </template>

                                    <template #cell(category)="data">
                                        <div style="max-width: 200px;">
                                            {{ data.item?.category?.title }}
                                        </div>
                                    </template>

                                    <template #cell(description)="row">
                                        <div v-if="row.item.description && row.item.description.length > 200" style="max-width: 400px;">
                                            <div v-html="row.item.description.slice(0, 200) + '...'"></div>
                                        </div>
                                        <div v-else style="max-width: 400px;">
                                            <div v-html="row.item.description"></div>
                                        </div>
                                    </template>

                                    <template #cell(image)="row">
                                        <div v-if="row.item.image">
                                            <img style="width: 120px; border-radius: 4px;" :src="host + row.item.image" alt="">
                                        </div>
                                    </template>

                                    <template #cell(featured)="row">
                                        <div>
                                            <span v-if="row.item.featured === true" style="cursor: pointer;">
                                                <b-badge pill variant="success" v-b-tooltip.hover title="Toggle featured" @click="toggleFeatured(row.item.slug)">Yes</b-badge>
                                            </span>
                                            <span v-if="row.item.featured === false" style="cursor: pointer;">
                                                <b-badge pill variant="danger" v-b-tooltip.hover title="Toggle featured" @click="toggleFeatured(row.item.slug)">No</b-badge>
                                            </span>
                                        </div>
                                    </template>

                                    <template #cell(custom)="row">
                                        <div>
                                            <span v-if="row.item.custom === true" style="display: flex; flex-direction: column; align-items: start;">
                                                <b-badge pill variant="success" v-b-tooltip.hover title="Toggle custom" @click="toggleCustom(row.item.slug)">Yes</b-badge>
                                                <router-link :to="`/custom-ui/research/${row.item.slug}`">
                                                    <b-badge pill variant="primary">Details</b-badge>
                                                </router-link>
                                            </span>
                                            <span v-else>
                                                <router-link :to="`/custom-ui/research/${row.item.slug}`">
                                                    <b-badge pill variant="danger" v-b-tooltip.hover title="Toggle custom">No</b-badge>
                                                </router-link>
                                            </span>
                                        </div>
                                    </template>

                                    <template #cell(serial)="row">
                                        <div style="max-width: 60px;">
                                            <input @keyup.enter="updateSerial(row.item)" @keyup="getSerial(row.item)" type="text" class="form-control" v-model="row.item.serial" placeholder="Enter Serial" />
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteResearch(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div @click="editResearch(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Research Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Research" size="xl" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" v-model="research.title" placeholder="Enter research title" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Category</label>
                        <select class="form-control digits" v-model="research.category">
                            <option v-for="(type, index) in categories" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Quote</label>
                        <input class="form-control" type="text" v-model="research.quote" placeholder="Enter research quote" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Redirection Link</label>
                        <input class="form-control" type="text" v-model="research.link" placeholder="Enter Redirection link" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Video Link</label>
                        <input class="form-control" type="text" v-model="research.video_link" placeholder="Enter research video link" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <ckeditor :editor="editor" v-model="research.description" placeholder="Enter research description"></ckeditor>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Image</label>
                    <div>
                        <img v-if="research.image" style="height: 80px; border-radius: 6px;" :src="research.image">
                        <input :class="research.image ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadResearchImage">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Research Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Research" size="xl" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" v-model="edit_research.title" placeholder="Enter research title" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Category</label>
                        <select class="form-control digits" v-model="edit_research.category">
                            <option v-for="(type, index) in categories" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Quote</label>
                        <input class="form-control" type="text" v-model="edit_research.quote" placeholder="Enter research quote" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Redirection Link</label>
                        <input class="form-control" type="text" v-model="edit_research.link" placeholder="Enter Redirection link" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Video Link</label>
                        <input class="form-control" type="text" v-model="edit_research.video_link" placeholder="Enter research video link" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <ckeditor :editor="editor" v-model="edit_research.description" placeholder="Enter research description"></ckeditor>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Image</label>
                    <div>
                        <img v-if="show_image" style="height: 80px; border-radius: 6px;" :src="show_image">
                        <input :class="show_image ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadResearchImage2">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Research Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this research?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    components: {
        loader
    },

    data() {
        return {
            editor: ClassicEditor,
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'category',
                    label: 'Category',
                    sortable: true
                },
                {
                    key: 'description',
                    label: 'Description',
                    sortable: true
                },
                {
                    key: 'image',
                    label: 'Image',
                    sortable: true
                },
                {
                    key: 'featured',
                    label: 'Featured',
                    sortable: true
                },
                {
                    key: 'custom',
                    label: 'Custom-UI',
                    sortable: true
                },
                {
                    key: 'serial',
                    label: 'Serial',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            research: {
                title: '',
                category: '',
                quote: '',
                link: '',
                video_link: '',
                description: '',
                image: null
            },

            edit_research: {
                id: '',
                title: '',
                category: '',
                quote: '',
                link: '',
                video_link: '',
                description: '',
                image: null
            },

            delete_value: null,
            show_image: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20],
            serial_wise_data: []
        };
    },

    computed: {
        ...mapState({
            research_list: state => state.research.research,
            categories: state => state.research.category,
            loading: state => state.research.researchLoading,
            error: state => state.research.researchError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("research/fetchCategory")
        this.$store.dispatch("research/fetchResearch").then(() => {
            this.items = this.research_list
            this.totalRows = this.research_list.length;
        });
    },

    methods: {
        updateSerial(pub) {
            this.$store.dispatch("research/updateSerial", pub).then(response => {
                if (response.data.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.$store.dispatch("research/fetchResearch").then(() => {
                        this.items = this.research_list
                        this.totalRows = this.research_list.length;
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        getSerial(data) {
            // remove the entry if user clears the serial
            if (!data.serial || data.serial.trim() === "") {
                this.serial_wise_data = this.serial_wise_data.filter(
                    item => item.id !== data.id
                );
                return;
            }

            // check if already exists
            const existing = this.serial_wise_data.find(item => item.id === data.id);

            if (existing) {
                // update serial
                existing.serial = data.serial;
            } else {
                // add new entry
                this.serial_wise_data.push({
                    id: data.id,
                    serial: data.serial
                });
            }
        },

        updateBulkSerial() {
            this.serial_wise_data.forEach(project => {
                this.$store.dispatch("research/updateSerial", project).then(response => {
                    if (response.data.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.$store.dispatch("research/fetchResearch").then(() => {
                            this.items = this.research_list
                            this.totalRows = this.research_list.length;
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                });
            });

            this.serial_wise_data = [];
        },

        toggleCustom(data) {
            this.$store.dispatch("research/customToggle", {
                custom_slug: data
            }).then(response => {
                if (response.code == 200) {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Success!',
                        detail: response.data.response,
                        closable: false,
                        life: 3000
                    })
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error!',
                        detail: response.data.response,
                        closable: false,
                        life: 3000
                    })
                }
            })
        },

        uploadResearchImage(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.research.image = e.target.result
            };
        },

        uploadResearchImage2(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.edit_research.image = e.target.result
                this.show_image = e.target.result
            };
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.research = {
                title: '',
                category: '',
                description: '',
                quote: '',
                link: '',
                video_link: '',
                image: null
            };
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("research/addResearch", {
                research: this.research
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editResearch(detail) {
            this.edit_research = {
                id: detail.id || null,
                title: detail.title || null,
                quote: detail.quote || null,
                link: detail.link || null,
                video_link: detail.video_link || null,
                category: detail ?.category ?.id || null,
                description: detail.description || null,
            };
            this.show_image = this.host + detail.image || null
        },

        resetEditModal() {
            this.edit_research = {
                id: '',
                title: '',
                category: '',
                quote: '',
                link: '',
                video_link: '',
                description: '',
                image: null
            };
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("research/updateResearch", {
                id: this.edit_research.id,
                research: this.edit_research
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        toggleFeatured(type) {
            this.$store.dispatch("research/toggleFeatured", {
                id: type
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        deleteResearch(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("research/deleteResearch", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
